import { Spin } from "antd"

const PageSpinner = ()=> {
    return(
        <div className={'grid place-items-center min-h-halfScreen min-w-full'}><Spin /></div>
    )
}

export default PageSpinner;